//获取代下单数据列表
export const GET_CLIENT_ORDER_LIST = "GET_CLIENT_ORDER_LIST";


// WEBPACK FOOTER //
// ./src/store/agent-purchase-list/type.js